import React, { Component } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { colors } from "./theme";

// Grouped bar chart for the V2 result pages.
//
// `series` is [{ key, name, color }] and `data` rows carry those keys plus a
// `name` used for the category axis. `layout="vertical"` draws horizontal bars
// (key topics, per-step pages), the default draws vertical ones (ELC steps).
export default class V2BarChart extends Component {
  render() {
    const {
      data,
      series,
      layout = "vertical",
      domain = [0, 3],
      ticks,
      threshold,
      height = 420,
      showValues = false,
      valueFormatter,
      categoryWidth = 160,
    } = this.props;

    const isHorizontalBars = layout === "vertical";
    const formatValue = valueFormatter || ((value) => value);

    return (
      <div className="report-v2__chart" style={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            layout={layout}
            margin={{ top: 16, right: 52, bottom: 8, left: -12 }}
            barCategoryGap={isHorizontalBars ? "22%" : "28%"}
            barGap={2}
          >
            <CartesianGrid stroke="transparent" />
            {isHorizontalBars ? (
              <>
                <XAxis
                  type="number"
                  domain={domain}
                  ticks={ticks}
                  tickLine={false}
                  axisLine={{ stroke: colors.cardBorder }}
                  tick={{ fill: colors.textMuted, fontSize: 12 }}
                />
                <YAxis
                  type="category"
                  dataKey="name"
                  width={categoryWidth}
                  tickLine={false}
                  axisLine={{ stroke: colors.cardBorder }}
                  tick={{ fill: colors.text, fontSize: 12 }}
                />
              </>
            ) : (
              <>
                <XAxis
                  type="category"
                  dataKey="name"
                  tickLine={false}
                  axisLine={{ stroke: colors.cardBorder }}
                  tick={{ fill: colors.text, fontSize: 11 }}
                />
                <YAxis
                  type="number"
                  domain={domain}
                  ticks={ticks}
                  tickLine={false}
                  axisLine={{ stroke: colors.cardBorder }}
                  tick={{ fill: colors.textMuted, fontSize: 12 }}
                />
              </>
            )}

            {threshold !== undefined && (
              <ReferenceLine
                {...(isHorizontalBars ? { x: threshold } : { y: threshold })}
                stroke={colors.threshold}
                strokeWidth={1}
              />
            )}

            {series.map((item) => (
              <Bar
                key={item.key}
                dataKey={item.key}
                name={item.name}
                fill={item.color}
                isAnimationActive={false}
              >
                {showValues && (
                  <LabelList
                    dataKey={item.key}
                    position={isHorizontalBars ? "right" : "top"}
                    formatter={formatValue}
                    style={{ fill: colors.text, fontSize: 11 }}
                  />
                )}
                {data.map((entry, index) => (
                  <Cell key={index} fill={item.color} />
                ))}
              </Bar>
            ))}

            {/* Aligned with the value axis rather than the chart edge: the
                category labels occupy `categoryWidth` on the left, so the
                legend is inset by the same amount. */}
            <Legend
              verticalAlign="bottom"
              align="left"
              iconType="square"
              iconSize={10}
              wrapperStyle={{
                fontSize: 12,
                color: colors.text,
                ...(isHorizontalBars ? { left: categoryWidth - 12 } : {}),
              }}
              // Recharts colours each label with its series colour inline,
              // which beats wrapperStyle. Only the square should carry the
              // colour, so the text is reset here.
              formatter={(value) => (
                <span style={{ color: colors.text }}>{value}</span>
              )}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
